var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJewelry4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type1_x5F_jewelry:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__9_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.6,430.3c-2.9,0.8-5.8,1.5-8.6,2.3c-2.9,0.7-5.8,1.4-8.6,2.1c-30.8,7.8-62.8,8.8-93.4,3.7c-2.7-0.5-5.4-1-8.1-1.6 c-8-1.8-15.9-4.2-23.5-7.2c-2.8,6.7-6.5,13.9-10.6,19.9c5.7,3,11.5,5.5,17.4,7.6c3,1,6,2,9,2.8c32.3,8.6,66.3,9.6,99,3.7 c3.4-0.6,6.8-1.2,10.2-2c10.1-2.3,20-5.4,29.5-9.8C436.2,446.2,431.3,436.3,428.6,430.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M447.4,444.5c0.1,0,0.2,0,0.3,0c-0.1,0-0.2-0.1-0.3-0.1C447.4,444.4,447.4,444.4,447.4,444.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M452.2,443.5c0.5,1.4-17.9,6.9-19.8,6.8s-3.4-3-3.2-6.6c0.1-3.6,1.8-6.5,3.7-6.4 C434.9,437.3,451.9,442.4,452.2,443.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M429.3,443c0,0.2,0,0.4,0,0.6c-0.1,2.4,0.5,4.5,1.5,5.6c-0.3-5.6,15-5.5,21.5-5.7v-0.1 C446,441.9,432.1,438.7,429.3,443z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M444.7,442.9c-3.9-0.2-9.1-0.6-12.7,1c-1.9,0.8-2.3,1.7-2.2,3.7c0.6,1.6,1.5,2.6,2.7,2.7 c1.9,0,19.6-5.1,19.8-6.7C449.9,443.2,446.9,443,444.7,442.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M448.5,444.5c-3,0.8-5.7,1-8.8,1.8c-2.7,0.7-4.8,1.5-7.5,2.1c2.7-0.5,5.1-0.7,7.7-1.3 C443,446.5,445.5,445.4,448.5,444.5L448.5,444.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M424.8,461.4c-0.9,1.4-17-7.6-18.2-9s0.4-4.5,3.5-7.1c3.1-2.5,6.5-3.4,7.7-2 C418.9,444.7,425.4,460.4,424.8,461.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M410.6,444.9c-0.2,0.1-0.4,0.3-0.6,0.4c-2,1.7-3.4,3.6-3.8,5.1c4.5-4.3,14,6.6,18.3,11c0,0,0.1,0,0.1-0.1 C422.1,455.9,416.1,443.7,410.6,444.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M420.5,455.7c-2.3-2.9-5.2-6.8-8.8-8.3c-1.9-0.7-2.9-0.4-4.5,1.2c-1,1.6-1.2,3-0.6,3.8 c1.1,1.4,16.6,10.1,18.1,9.1C423.4,459.6,421.8,457.3,420.5,455.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M421.5,459.5c-2.5-1.6-4.5-3.3-7.1-4.9c-2.2-1.4-4.3-2.3-6.5-3.7c2.1,1.5,3.7,3.1,6,4.5 C416.5,457.1,418.9,458.1,421.5,459.5L421.5,459.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M392.6,468.9c-1.3,0.9-12-13-12.5-14.6s2-3.9,5.7-5c3.6-1.1,7-0.7,7.5,1 C393.7,451.9,393.5,468.2,392.6,468.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M386.4,449.1c-0.2,0.1-0.4,0.1-0.7,0.2c-2.4,0.7-4.3,2-5.2,3.2c5.5-2.2,9.8,10.9,11.9,16.5h0.1 C392.3,463,391.6,450,386.4,449.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M390.9,462.2c-1-3.4-2.1-8-4.7-10.5c-1.4-1.3-2.4-1.4-4.3-0.6c-1.4,1-2.2,2.2-1.9,3.2 c0.5,1.6,10.8,15,12.5,14.6C392.1,466.7,391.5,464.2,390.9,462.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M390.4,466c-1.6-2.3-2.7-4.5-4.4-6.9c-1.4-2.1-2.9-3.6-4.3-5.7c1.2,2.1,2.1,4.1,3.5,6.2 C386.9,462,388.7,463.7,390.4,466L390.4,466z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M265.3,442.1c-0.5,1.5,17.4,7.3,19.3,7.2s3.3-3.2,3.2-7c-0.1-3.8-1.7-6.8-3.6-6.8 C282.3,435.6,265.6,440.9,265.3,442.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M287.7,441.6c0,0.2,0,0.5,0,0.7c0.1,2.5-0.5,4.7-1.5,5.9c0.3-5.9-14.6-5.8-21-6.1V442 C271.4,440.4,285,437,287.7,441.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M272.6,441.5c3.8-0.2,8.9-0.6,12.4,1.1c1.8,0.9,2.3,1.8,2.1,3.9c-0.6,1.7-1.5,2.8-2.6,2.8 c-1.8,0-19.1-5.5-19.3-7.1C267.6,441.8,270.5,441.6,272.6,441.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M269,443.2c2.9,0.8,5.6,1.1,8.6,1.9c2.6,0.7,4.7,1.6,7.3,2.3c-2.6-0.5-4.9-0.7-7.6-1.4 C274.2,445.2,271.9,444.1,269,443.2L269,443.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M292.5,461.2c0.8,1.4,17.2-6.5,18.4-7.8c1.2-1.3-0.1-4.5-3-7.2s-6.2-3.8-7.4-2.5 C299.2,445,291.9,460.1,292.5,461.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M307.4,445.7c0.2,0.1,0.4,0.3,0.5,0.5c1.9,1.8,3.1,3.8,3.4,5.3c-4.1-4.5-14.2,5.7-18.7,9.8l-0.1-0.1 C295.4,455.8,302.1,444.2,307.4,445.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M297.1,455.8c2.5-2.7,5.6-6.4,9.2-7.6c1.9-0.6,2.9-0.2,4.3,1.4c0.9,1.6,1,3,0.3,3.8 c-1.2,1.3-17,9-18.3,7.9C293.9,459.4,295.7,457.3,297.1,455.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M295.8,459.5c2.6-1.4,4.6-3,7.2-4.4c2.3-1.2,4.4-2,6.6-3.3c-2.1,1.4-3.9,2.8-6.1,4.1 C300.9,457.4,298.5,458.2,295.8,459.5L295.8,459.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M326.4,469.7c1.3,0.9,11.9-13.1,12.4-14.7s-2.1-3.9-5.7-4.9c-3.6-1.1-7-0.6-7.5,1.1 C325.1,452.7,325.4,469,326.4,469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M332.4,449.8c0.2,0.1,0.4,0.1,0.7,0.2c2.4,0.7,4.3,1.9,5.2,3.1c-5.5-2.1-9.7,11.1-11.8,16.6h-0.1 C326.6,463.8,327.2,450.8,332.4,449.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M328,463c0.9-3.4,2-8,4.5-10.6c1.3-1.4,2.4-1.4,4.3-0.7c1.4,1,2.2,2.2,1.9,3.2 c-0.5,1.6-10.6,15.1-12.3,14.8C326.8,467.5,327.5,465,328,463z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M328.5,466.8c1.6-2.3,2.6-4.6,4.3-7c1.4-2.1,2.9-3.6,4.2-5.7c-1.2,2.1-2.1,4.1-3.5,6.2 C332,462.8,330.2,464.5,328.5,466.8L328.5,466.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M360.4,474.5c-1.5,0.5-7.6-17.8-7.6-19.7c0-1.9,3.1-3.4,6.9-3.4s6.9,1.6,6.8,3.6 C366.6,456.9,361.6,474.1,360.4,474.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M360.5,451.5c-0.2,0-0.5,0-0.7,0c-2.5,0-4.7,0.6-5.9,1.6c5.9-0.5,6.1,14.9,6.4,21.4h0.1 C362,468.2,365.2,454.2,360.5,451.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M360.9,466.9c0.1-3.9,0.4-9.1-1.3-12.7c-0.9-1.9-1.9-2.3-4-2.1c-1.7,0.6-2.8,1.6-2.8,2.7 c0,1.9,5.8,19.5,7.5,19.7C360.6,472.1,360.8,469.1,360.9,466.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M359.2,470.7c-0.9-3-1.2-5.7-2.1-8.8c-0.8-2.7-1.7-4.8-2.4-7.4c0.5,2.7,0.8,5.1,1.5,7.7 C357.1,465.3,358.3,467.8,359.2,470.7L359.2,470.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJewelry4);
export default __webpack_public_path__ + "static/media/new_jewelry_4.9feea753ad7f4d4b2b39aedad34106bc.svg";
export { ForwardRef as ReactComponent };